import { formatPrice } from 'utils/helpers';

import * as Styles from './styles';

// Owner 20 Oct 2026: per show, the product cost that left with missing sales.
// Those sales never went through a POS checkout, so nothing was taken from
// stock; the counts below stay as they are. Hidden when there is none.
export const missingSalesCogsText = (amount?: number | null) =>
  typeof amount === 'number' && amount > 0
    ? `Missing sales: ${formatPrice(amount)} product cost, not taken from stock`
    : null;

export const MissingSalesCogsNote = ({
  amount,
}: {
  amount?: number | null;
}) => {
  const text = missingSalesCogsText(amount);

  return text ? (
    <Styles.MissingSalesNote data-testid="missing-sales-cogs-note">
      {text}
    </Styles.MissingSalesNote>
  ) : null;
};
